import { Link } from 'react-router-dom';
import { getLatestPosts } from '../../utils/blogLoader';

export default function LatestPosts() {
  const posts = getLatestPosts(3);

  return (
    <section className="posts">
      <div className="container">
        <div className="section-header">
          <h2>Latest Blog Posts</h2>
        </div>
        <div className="posts-list">
          {posts.map((post) => (
            <article key={post.slug} className="post-item">
              <div className="post-date">[{post.date}]</div>
              <h3 className="post-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h3>
              {post.excerpt && (
                <div className="post-excerpt">{post.excerpt}</div>
              )}
            </article>
          ))}
        </div>
        
        <div className="posts-link">
          <Link to="/blog">→ View all blog posts</Link>
        </div>
      </div>
    </section>
  );
}
